import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-x-3" }
const _hoisted_2 = { class: "relative w-1/2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", { value: "lowerThan" }, "Lower than", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: "greaterThan" }, "Greater than", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "relative w-1/2" }
const _hoisted_7 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.condition) = $event)),
        class: "h-42"
      }, _hoisted_5, 512), [
        [_vModelSelect, _ctx.localValue.condition]
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("input", {
        value: _ctx.localValue.value,
        onInput: _cache[1] || (_cache[1] = (e) => _ctx.onSetItem(e.target.value)),
        type: "number",
        class: "form-control h-42",
        placeholder: "Min"
      }, null, 40, _hoisted_7)
    ])
  ]))
}